import { S_DEBUG_MODE } from './config'
import { hasMappedHeaders } from './utils'

export function isNotNullOrEmptyString(s: any): boolean {
  return s && s?.toString().trim() != '' ? true : false
}

export function isNullOrEmptyString(s: any): boolean {
  return !s || s?.toString().trim() == '' ? true : false
}

export function toTrimmedString(s: any): string {
  return s ? s?.toString().trim() : ''
}

export function toTrimmedStringLowerCase(s: any): string {
  return s ? s?.toString().trim().toLowerCase() : ''
}

export function isNotNullOrUndefined(s: any): boolean {
  return s != null && s != undefined
}

const encryptionShift: number = 3

export function simpleEncrypt(text: any) {
  let encryptedText = ''
  try {
    for (let i = 0; i < text.length; i++) {
      let charCode = text.charCodeAt(i)
      if (charCode >= 32 && charCode <= 126)
        charCode = ((charCode - 32 + encryptionShift) % 95) + 32
      encryptedText += String.fromCharCode(charCode)
    }
  } catch (e) {
    if (S_DEBUG_MODE) console.log(e)
  }
  return encryptedText
}

export function simpleDecrypt(encryptedText: any) {
  let decryptedText = ''
  try {
    for (let i = 0; i < encryptedText.length; i++) {
      let charCode = encryptedText.charCodeAt(i)
      if (charCode >= 32 && charCode <= 126)
        charCode = ((charCode - 32 - encryptionShift + 95) % 95) + 32
      decryptedText += String.fromCharCode(charCode)
    }
  } catch (e) {
    if (S_DEBUG_MODE) console.log(e)
  }
  return decryptedText
}

export function validateAsInternalRequest(
  headers: any,
  threshold: any,
): boolean {
  let ret: boolean = true
  try {
    const mappedHeaders: boolean = hasMappedHeaders(headers)
    if (S_DEBUG_MODE) console.log(mappedHeaders)
    let correctCount: number = 0
    headers['cookie'] &&
      (toTrimmedStringLowerCase(headers['cookie'])
        .toString()
        ?.indexOf('next-auth.csrf-token') > -1 ||
        toTrimmedStringLowerCase(headers['cookie'])
          .toString()
          ?.indexOf('__Host-next-auth.csrf-token') > -1)
    correctCount++
    if (headers['x-invoke-path'] && headers['x-invoke-path'].toString() != '')
      correctCount++
    if (
      headers['x-middleware-invoke'] &&
      headers['x-middleware-invoke'].toString() != ''
    )
      correctCount++
    if (
      headers['x-invoke-output'] &&
      headers['x-invoke-output'].toString() != ''
    )
      correctCount++
    if (
      headers['sec-fetch-site'] &&
      toTrimmedStringLowerCase(headers['sec-fetch-site'])
        .toString()
        ?.indexOf('same-origin') == 0
    )
      correctCount++
    if (
      headers['sec-fetch-mode'] &&
      toTrimmedStringLowerCase(headers['sec-fetch-mode'])
        .toString()
        ?.indexOf('cors') == 0
    )
      correctCount++
    if (
      headers['sec-fetch-dest'] &&
      toTrimmedStringLowerCase(headers['sec-fetch-dest'])
        .toString()
        ?.indexOf('empty') == 0
    )
      correctCount++
    if (S_DEBUG_MODE) console.log(headers)
    if (S_DEBUG_MODE) console.log(correctCount)
    ret = correctCount < threshold ? false : true
  } catch (e) {
    if (S_DEBUG_MODE) console.log(e)
  }
  return ret
}

export function resolveIconUrl(foundPath: any, baseUrl: string): string {
  let retVal: string = ''
  try {
    const domain: string = baseUrl ? new URL(baseUrl).hostname : 'default.com'
    const size: string = '128'
    const googleFallback: string = `https://www.google.com/s2/favicons?domain=${domain}&sz=${size}`
    if (isNullOrEmptyString(foundPath)) retVal = googleFallback
    else {
      try {
        if (foundPath.startsWith('//')) {
          retVal = `https:${foundPath}`
        }
        const resolved: URL = new URL(foundPath, baseUrl)
        if (resolved.protocol === 'http:') resolved.protocol = 'https:'
        retVal = resolved.href
      } catch (e) {
        if (S_DEBUG_MODE) console.log(e)
        retVal = googleFallback
      }
    }
  } catch (e) {
    if (S_DEBUG_MODE) console.log(e)
  }
  return retVal
}
